var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small text-right pt-2 global-source"},[_vm._v(" 資料來源網址："),_c('a',{attrs:{"target":"_blank","href":_vm.href}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }